module.exports = __webpack_public_path__ + "static/img/6.35e555e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/eng/6.png
// module id = 5AYD
// module chunks = 0